<template>
  <Card pt:content:class="p-0!" pt:body:class="p-2!">
    <template #content>
      <div class="flex flex-row justify-evenly gap-4">
        <div class="h-[70vh] flex flex-col w-full gap-3">
          <Card class="h-full flex flex-col" pt:body:class="p-0! flex flex-col flex-1 min-h-0" pt:content:class="p-0! flex flex-col flex-1 min-h-0">
            <template #header>
              <div class="flex flex-row flex-1 justify-center gap-1 h-12">
                <i class="pi pi-send text-xl! my-auto"></i>

                <h1 class="font-bold text-xl my-auto">Correspondence</h1>
              </div>
            </template>
            <template #content>
              <ActivityLogContactTable
                :project="project"
                :activity-log-contacts="activityLogContacts"
                :reached-allocated-inspections="reachedAllocatedInspections"
              ></ActivityLogContactTable>
              <ActivityLogEntryTable :activity-log-entries="correspondenceEntries" class="basis-1/2"></ActivityLogEntryTable>
            </template>
          </Card>
        </div>
        <div class="h-[70vh] flex-col w-full">
          <RecentActivity :activity-list="activityLogEntries" height="flex-1 min-h-0" class="h-full flex flex-col"></RecentActivity>
        </div>
      </div>
    </template>
  </Card>
</template>

<script setup lang="ts">
import type { Project } from "@/types/Projects";
import type { CorrespondenceEntry, ActivityLogContact, Activity } from "@/types/ActivityLog";
import ActivityLogEntryTable from "./CorrespondenceEntryTable.vue";
import ActivityLogContactTable from "./CorrespondenceContactTable.vue";

const project = defineModel<Project>("project", { required: true });
const correspondenceEntries = defineModel<CorrespondenceEntry[]>("correspondenceEntries", { required: true });
const activityLogContacts = defineModel<ActivityLogContact[]>("activityLogContacts", { required: true });
const reachedAllocatedInspections = defineModel<boolean>("reachedAllocatedInspections", { required: true });
const activityLogEntries = defineModel<Activity[]>("activityLogEntries", { required: true });
</script>
